export default "__VITE_ASSET__blQfzyj1__"